import { useParams } from "react-router-dom"

import moment from "moment"
import { DatePicker, List, Modal, Button, Divider, Spin } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { getLatestReadings } from "../../../redux/actions/patientAction"
import dayjs from "dayjs"

const monthFormat = "YYYY/MM"

const ReadingDiv = props => {
  const {
    readingMonth,
    setReadingMonth,
    showReadingModal,
    setShowReadingModal,
    patientLatestReading,
    currentMonthReading
  } = props

  const patientId = useParams()
  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.patientReading)

  const handleReadingModalClose = () => {
    const currentDate = dayjs()
    if (currentDate.format(monthFormat) !== readingMonth?.format(monthFormat)) {
      setReadingMonth(currentDate)
      dispatch(getLatestReadings(patientId.id))
    }
    setShowReadingModal(false)
  }

  const onChange = (date) => {
    const selectedDate = date || dayjs()
    setReadingMonth(selectedDate)
    dispatch(getLatestReadings(
      patientId.id, 
      selectedDate.month() + 1, 
      selectedDate.year()
    ))
  }

  

  // const currMonth = new Date().getMonth() + 1
  // const currYear = new Date().getFullYear()

  const disableDate = current => {
    return current > dayjs()
  }
  const getDisplayMonth = () => {
    if (!readingMonth) return dayjs().format("MMMM")
    
    if (patientLatestReading?.length) {
      const monthIndex = patientLatestReading[0]?.month - 1
      return dayjs().month(monthIndex).format("MMMM")
    }
    
    return readingMonth.format("MMMM")
  }

  const getReadingCount = () => {
    if (patientLatestReading?.length) return patientLatestReading.length
    if (patientLatestReading?.count) return patientLatestReading.count
    
    const currentMonth = dayjs().month()
    const selectedMonth = readingMonth?.month() || currentMonth
    const latestMonth = (patientLatestReading?.[0]?.month || 0) - 1

    if (latestMonth === selectedMonth || selectedMonth === currentMonth) {
      return currentMonthReading || 0
    }
    return 0
  }

  return (
    <Modal
      footer={null}
      open={showReadingModal}
      onCancel={() => setShowReadingModal(false)}
      title={<h4 className="text-xl">Reading Count</h4>}>
      <div className="pt-4">
        {loading ? <div className="d-flex justify-content-center align-items-center my-1">
          <Spin size="large" />
        </div> :
          <p>
            {getDisplayMonth()} Reading Count:
            <span className="pl-2 text-current font-bold"> {getReadingCount()}</span>
          </p>}
        <DatePicker
          disabledDate={disableDate}
          disabled={loading}
          picker="month"
          onChange={onChange}
          format={monthFormat}
          className="mt-4 w-full"
          value={readingMonth}
          allowClear={true}
        />

        <div className="flex flex-wrap items-center gap-3 mt-4">
          <Button type="primary" onClick={() => setShowReadingModal(false)}>
            Confirm
          </Button>
          <Button danger onClick={handleReadingModalClose}>
            Reset
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ReadingDiv
